type Timestamper = () => number;

export const timestamper: Timestamper = () =>
  typeof performance !== "undefined" ? performance.now() : Date.now();
